// import { useCallback } from 'react';
import { Field, Form } from 'react-final-form';
import { validateFormValues } from '../helpers';
import * as yup from 'yup';
import FormError from '../components/Common/FormError';
import { Link } from 'react-router-dom';
import useSignin from '../hooks/auth/useSignin';
import LoadingIndicator from '../components/Common/LoadingIndicator';
import Notify from '../components/Common/Notify';

const SigninPage = () => {
  const validationSchema = yup.object({
    email: yup.string().required('Email address is required').email('Please enter a valid email address'),
    password: yup.string().required('Please enter a password'),
  });
  const validate = validateFormValues(validationSchema);

  const { onSubmitHandler, submiting, error } = useSignin();

  console.log('signin');

  return (
    <>
      <Form
        onSubmit={onSubmitHandler}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className='p-12'>
            <h2>Account Sign In</h2>
            <h6 className='mb-10'>
              <span className='text-muted'>New to MortFi?</span> <Link to='/signup'>Create An Account</Link>
            </h6>

            {error && <Notify type='danger' message={error} />}

            <div className='mb-5 col-lg-12'>
              <Field name='email' type='email'>
                {({ input, meta }) => (
                  <>
                    <label className='form-label'>Email</label>
                    <div className='mb-3'>
                      <input type='email' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-12'>
              <Field name='password'>
                {({ input, meta }) => (
                  <>
                    <label className='form-label'>Password</label>
                    <div className='mb-3'>
                      <input type='password' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-md-12'>
              <button type='submit' disabled={submiting} className='btn btn-primary btn-block w-100'>
                {submiting ? <LoadingIndicator /> : 'Sign In'}
              </button>
            </div>
            <h6 className='text-center mt-5'>
              <Link to='/forgot-password'>Forgot Your Password?</Link>
            </h6>
          </form>
        )}
      />
    </>
  );
};

export default SigninPage;
